import { PersonsV3 } from '@frontend/api-person';
import { useMemoizedArray, useMultiQueryUtils } from '@frontend/payments-hooks';

type UsePersonLocationsOptions = {
  locationIds?: (string | undefined)[];
  personId: string | undefined;
};

export const usePersonLocations = ({ locationIds: passedInLocationIds, personId }: UsePersonLocationsOptions) => {
  const { locationIds: locationIdsFromUtils } = useMultiQueryUtils();
  const locationIds = useMemoizedArray(passedInLocationIds ?? locationIdsFromUtils);

  const personPerLocationQueries = PersonsV3.PersonQueries.useGetPersonPerLocationQueries(
    { locationIds, personId: personId ?? '' },
    { enabled: locationIds.length > 0 && !!personId }
  );
  const { personLocations, isLoading } = personPerLocationQueries.reduce(
    (acc, queryResult) => {
      if (queryResult.data?.person?.personId) {
        acc.personLocations.push(queryResult.data.locationId);
      }
      acc.isLoading = acc.isLoading || queryResult.isLoading;
      return acc;
    },
    { personLocations: [] as string[], isLoading: false }
  );
  const personLocationIds = useMemoizedArray(personLocations);

  return {
    personLocationIds: personId ? personLocationIds : locationIds,
    selectedLocationIds: locationIds,
    isLoading,
  };
};
